export default "__VITE_ASSET__BSbHgler__"